import { useEffect, useState } from 'react';
import GoalIcon from '../../Icons/GoalIcon';
import ModuleIcon from '../../Icons/ModuleIcon';
import SurveyIcon from '../../Icons/SurveyIcon';
import UnreadMessageIcon from '../../Icons/UnreadMessageIcon';
import './PatientList.css';

const PatientList = ({ patients, selectPatient }) => {
  const [allPatients, setAllPatients] = useState();
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    setAllPatients(patients);
    setLoader(true);
  }, [patients]);

  if (loader) {
    return (
      <div className='patientList'>
        {allPatients.map((patient) => {
          const numberOfMessages = patient.messages.length;
          if (numberOfMessages >= 0) {
            const sortedMessages = patient?.messages.sort(
              (a, b) => a.Id - b.Id
            );

            const message =
              numberOfMessages > 0
                ? sortedMessages[numberOfMessages - 1]
                : { Body: 'Start a conversation' };
            return (
              <div
                className='patient'
                key={patient.Id}
                onClick={() => {
                  selectPatient(patient);
                }}
              >
                <div>
                  <h6>
                    {patient.FirstName} {patient.LastName}
                  </h6>
                  <div>
                    <>
                      <div className='row'>
                        <div className='col-10 ' style={{ marginTop: '1.5%' }}>
                          {message?.Body === null ? (
                            <div className='row'>
                              <div className='col-2 pe-0'>
                                {message?.UserActivityMapping?.Activity
                                  ?.ActivityType === '0' && <SurveyIcon />}
                                {message?.UserActivityMapping?.Activity
                                  ?.ActivityType === '1' && <GoalIcon />}
                                {message?.UserActivityMapping?.Activity
                                  ?.ActivityType === '2' && <ModuleIcon />}
                              </div>
                              <div className='col-10'>
                                {message?.UserActivityMapping?.Activity?.Title}
                              </div>
                            </div>
                          ) : (
                            <div className='d-block small opacity-50'>
                              {message?.Body?.substring(0, 30)}{' '}
                              {patient?.messages[numberOfMessages - 1]?.Body
                                ?.length > 30 && <>...</>}
                            </div>
                          )}
                        </div>

                        <div className='col-1'>
                          {message?.CreatedBy === patient?.Id &&
                          !message?.HasRead ? (
                            <UnreadMessageIcon />
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>
                  </div>
                </div>
              </div>
            );
          }
        })}
      </div>
    );
  } else {
    return <div>Loading</div>;
  }
};

export default PatientList;
